export function isUdrCode(code: string) {
  return /^03\.[0-9]{2}\.[0-9]{2}$/.test(code);
}

export function gmrCodeForUdr(code: string) {
  return isUdrCode(code) ? code.replace(/\.[^.]+$/, "") : null;
}

export function lineCenterCodeForTask(taskCode: string) {
  if (taskCode.startsWith("M1.02.") || taskCode.startsWith("M1.04.")) return "01.01";
  if (taskCode.startsWith("M1.05.")) return "01.02";
  if (taskCode.startsWith("M1.06.")) return "01.03";
  if (taskCode.startsWith("S1.01.")) return null;
  return undefined;
}

export function isReviewerCenter(code: string) {
  return /^(03\.0[1-6]|01\.0[1-3])$/.test(code);
}
